<div class="case-summary-form">
    <gen-dynamic-form
            [formName]="formId"
            [formData]="testFormData"
            [submitButtonText]="saveButtonText"
            [disabled]="formDisabled"
            [mode]="testFormData ? 'text' : 'form'"
            (submitEmitter)="saveData($event)"
    >
    </gen-dynamic-form>
</div>
